<template>
  <div class="static receiving">
	<div class="logo-left">
	  <a href="/storesafe" target="_parent">
		<img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
	  </a>
	</div>
	<h1>{{ $t('receiving.page_title') }}</h1>
  </div>

  <div class="static-grey">
	{{ $t('receiving.intro_text') }}
  </div>
  <div class="static-white">
    <div class="static-split">
		<div class="split-image">
		  <img src="@/assets/images/receiving_dunnage-rack.png" alt="Dunnage Stand">
		</div>
		<div class="split-content">
		  <h2>{{ $t('receiving.dunnage_rack') }}</h2>
		  <p>{{ $t('receiving.store_food_beverage_shipments_twelve_inc') }}</p>
		  <a href="https://www.cambro.com/Products/shelving/dunnage-racks-/" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true"
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('receiving.learn_more_btn') }}
		  </button></a>
		</div>
 	</div>
	 
	 <div class="static-testimonial">
		 <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		 <div class="testimonial-quote">{{ $t('receiving.overall_these_shelving_units_helped_orga') }}&quot;</div>
		 <div class="testimonial-pic"><img src="@/assets/images/receiving_testimonial-1.png" /></div>
		 <div class="testimonial-name"><a href="https://blog.cambro.com/2018/05/30/before-after-the-install-shorebreak-hotel-beverage-cooler/" target="_blank">{{ $t('receiving.eric_zunigg_food_and_beverage_manager_at') }}</a></div>
	 </div>
	 
	<div class="static-split red-line">
		<div class="split-image">
		  <img src="@/assets/images/receiving_sanitizer.png" alt="Sanitizer shaker">
		</div>
		<div class="split-content">
		  <h2 v-html="$t('receiving.sanitizer_only_personalized_shakers')"></h2>
		  <p>{{ $t('receiving.store_clean_temperature_measuring_device') }}</p>
		  <a href="https://www.cambro.com/personalize" target="_blank" class="learn-more">
		  <button @mouseover="isHovered = true"
				  @mouseleave="isHovered = false"
				  :class="{ 'hovered': isHovered }">
			{{ $t('receiving.learn_more_btn') }}
		  </button></a>
		</div>
	 </div>
	 
	 <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/receiving_service-cart.png" alt="Service Cart Pro">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('receiving.service_cart_pro') }}</h2>
		   <h3>{{ $t('receiving.large_medium_sizes') }}</h3>
		   <p>{{ $t('receiving.transport_up_to_600_lbs_of_ingredients_i') }}</p>
		   <a href="https://www.cambro.com/Products/food-and-salad-bars/service-and-utility-carts/service-cart-pro/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true"
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn') }}
		   </button></a>
		 </div>
	  </div>
	  
	  <div class="sub-white">
		<h1>{{ $t('receiving.other_resources_title') }}</h1>
		<div class="home-categories">
			<a href="#" class="home-cat dimmed"><div class="cat-receiving"></div></a>
			<a href="/storesafe/storage" target="_parent" class="home-cat"><div class="cat-storage"></div></a>
			<a href="/storesafe/preparation" target="_parent" class="home-cat"><div class="cat-prep"></div></a>
			<a href="/storesafe/service" target="_parent" class="home-cat"><div class="cat-service"></div></a>
			<a href="/storesafe/warewashing" target="_parent" class="home-cat"><div class="cat-warewashing"></div></a>
		</div>
	  </div>
	  
  	</div>


</template>

